import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { SatPopoverComponent } from '@ncstate/sat-popover';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, skipWhile, switchMap, tap } from 'rxjs/operators';
import { LoanAction } from '../../models';
import { isLondonWorkingHours } from '../../utils';

@Component({
  selector: 'sg-borrow-rate-request-button',
  templateUrl: './borrow-rate-request-button.component.html',
  styleUrls: ['./borrow-rate-request-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SgBorrowRateRequestButtonComponent implements OnInit, AfterViewChecked {
  @Input() isOperationInProgress$: Observable<boolean>;
  @Input() isBorrow: boolean;

  @ViewChild('rateRequestPopover') rateRequestPopover: SatPopoverComponent;

  @Output() onclick = new EventEmitter<LoanAction>();

  isLoading$: Observable<boolean>;
  popoverMessage = this.getPopoverMessage();
  private _clickedBeforeOperation$ = new BehaviorSubject<boolean>(false);

  constructor() {}

  ngOnInit(): void {
    if (this.isOperationInProgress$) {
      this.isLoading$ = this._clickedBeforeOperation$.pipe(
        switchMap((clickedBeforeOperation) => {
          return this.isOperationInProgress$.pipe(
            skipWhile((value) => value === false),
            map((isOperationInProgress) => [clickedBeforeOperation, isOperationInProgress])
          );
        }),
        tap(([clickedBeforeOperation, isOperationInProgress]) => {
          if (!isOperationInProgress && clickedBeforeOperation) {
            this._clickedBeforeOperation$.next(false);
          }
        }),
        map(([isOperationInProgress, clickedBeforeOperation]) => isOperationInProgress && clickedBeforeOperation)
      );
    }
  }

  ngAfterViewChecked(): void {
    const isRateRequestPromo = coerceBooleanProperty(localStorage.getItem('rateRequestPromo'));
    if (!isRateRequestPromo && !!this.rateRequestPopover) {
      this.rateRequestPopover.open();
      localStorage.setItem('rateRequestPromo', 'true');
    }
  }

  onClick(type: LoanAction): void {
    this._clickedBeforeOperation$.next(true);
    this.onclick.emit(type);
  }

  private getPopoverMessage(): string {
    const isWorkingHours = isLondonWorkingHours();
    const workingHoursMessage = `Send us your rate request and we'll fill or cancel shortly. Our trading desk will notify you.`;
    const nonWorkingHoursMessage = `Send us your rate request and desk will respond when available (Out of trading hours).`;
    return isWorkingHours ? workingHoursMessage : nonWorkingHoursMessage;
  }
}
